import template from './fileUploadField.html';
import controller from './fileUploadField.controller';

import './fileUploadField.css';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    fieldResponse: '<',
    onUpdate: '&',
  }
};

export default component;
